import { render, staticRenderFns } from "./service-task-item.vue?vue&type=template&id=3616743c&scoped=true"
import script from "./service-task-item.vue?vue&type=script&lang=js"
export * from "./service-task-item.vue?vue&type=script&lang=js"
import style0 from "./service-task-item.vue?vue&type=style&index=0&id=3616743c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616743c",
  null
  
)

export default component.exports